// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const regenerateEntryNotesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const regenerateEntryNotesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Note regeneration started
 */
export const regenerateEntryNotes202Schema = z.object({
  message: z.coerce.string(),
  job_id: z.optional(z.coerce.string()),
  estimated_completion_time: z.optional(z.coerce.string()),
});

/**
 * @description No activities to summarize for the entry
 */
export const regenerateEntryNotes400Schema = z.object({
  message: z.coerce.string(),
  errors: z.optional(z.array(z.object({
    field: z.optional(z.coerce.string()),
    message: z.optional(z.coerce.string()),
  }))),
});

export const regenerateEntryNotesMutationRequestSchema = z.object({
  date: z.string().date(),
  timely_account_id: z.number().int(),
  timely_user_id: z.number().int(),
  entry_id: z.coerce.string().describe("Optional entry ID to regenerate a single entry; omit to regenerate all edited entries on the date.").nullish(),
  session_id: z.number().int().nullish(),
  metadata: z.optional(z.object({
    note_language: z.optional(z.coerce.string()),
  })),
});

export const regenerateEntryNotesMutationResponseSchema = z.lazy(() => regenerateEntryNotes202Schema);
